let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5rqCJ")).then(() => parcelRequire('5TzXI'));